<div class="flex align-items-center justify-content-center min-h-screen surface-ground">
  <p-card class="text-center w-11 md:w-6 lg:w-4 min-h-40 flex flex-column justify-content-center p-4">
    <ng-template pTemplate="title">
      <span class="title text-2xl font-bold">{{'LABEL_PAGE_NOT_FOUND' | translate}}</span>
    </ng-template>

    <ng-template pTemplate="content">
      <button
        pButton
        type="button"
        label="{{'LABEL_DECLARE_AN_INCIDENT' | translate}}"
        icon="pi pi-exclamation-circle"
        class="p-button-lg p-button-primary mt-4"
        (click)="openTopdesk()"
      ></button>
    </ng-template>
  </p-card>
</div>